<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
export default {
  name: 'App',
  async mounted() {},
  methods: {
    ...mapActions('transaction', ['getSalesByDate']),
    ...mapActions('mvm', ['getMvms']),
  },
};
</script>
